import { render, staticRenderFns } from "./WelcomeRedirect.vue?vue&type=template&id=41c8f6ea&"
import script from "./WelcomeRedirect.vue?vue&type=script&lang=ts&"
export * from "./WelcomeRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports